/**
 * Retrieves the name of a page from a given path based on the specified level.
 *
 * @param path - The string representing the path, with segments separated by '/'.
 * @param level - The level of the page name to retrieve (1-based index).
 * @returns The name of the page at the specified level, or an empty string if the level is out of bounds.
 */
export function getPageName(path: string, level: number) {
  const pathArray = path.split('/');

  if (pathArray.length >= level) {
    return pathArray[level - 1];
  } else {
    return '';
  }
}
